export function customizeBreadcrumb(vm, cameraName) {
  const customBreadcrumbTitleEl = document.getElementById(
    "custom-breadcrumb-title"
  );
  if (customBreadcrumbTitleEl) {
    vm.$nextTick(() => {
      if (!document.getElementById("custom-breadcrumb-item-name")) {
        const basePositionEl = document.querySelector("div.router-view");
        const ulElement = document.querySelector("div.vx-breadcrumb ul");
        customBreadcrumbTitleEl.style["left"] =
          ulElement.children[
            ulElement.children.length - 1
          ].getBoundingClientRect().left -
          basePositionEl.getBoundingClientRect().left +
          "px";
        customBreadcrumbTitleEl.style["top"] =
          ulElement.getBoundingClientRect().top + "px";
        customBreadcrumbTitleEl.style["height"] =
          ulElement.getBoundingClientRect().height + "px";
        const breadcrumbItemCopyEl = ulElement.children[
          ulElement.children.length - 1
        ].cloneNode(true);
        customBreadcrumbTitleEl.appendChild(
          breadcrumbItemCopyEl.firstChild.cloneNode(true)
        );
        customBreadcrumbTitleEl.lastChild.id = "custom-breadcrumb-item-name";
      }
      customBreadcrumbTitleEl.lastChild.innerText = cameraName;
    });
  }
}

export function sleep(waitSec) {
  return new Promise(resolve => setTimeout(resolve, waitSec * 1000));
}

export function zoomList(cameraZoomMin, cameraZoomMax) {
  const zoomList = [];
  for (let i = cameraZoomMin; i <= cameraZoomMax; i++) {
    zoomList.push(i);
  }
  return zoomList;
}
